import { createPath } from '../../../utils';

/**
 * Landing page for a Shopee authorization completed by someone outside AnyX.
 *
 * Deliberately workspace-free and outside the authenticated app: the person who lands here is the
 * merchant's own main-account user, who has no AnyX login and no workspace (anyx#1705). Any path
 * built from `useWorkspaceCtx` — as `OauthRoutePath` is — is unusable for them, so this follows the
 * `ErrorsRoutePath` / `PolicyModuleRoutesPaths` shape instead.
 */
export const ShopeeAuthorizationRoutePath = () => {
  const root = createPath('/shopee-authorization');

  return {
    root: () => root,
    complete: () => createPath(`${root.path}/complete`),
  };
};
